import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

export const IconFilters = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 20 20" fill="none">
    <path
      d="M1.66663 3.66666C1.66663 2.56209 2.56206 1.66666 3.66663 1.66666H16.3333C17.4379 1.66666 18.3333 2.56209 18.3333 3.66666V3.8175C18.3333 4.57738 18.0449 5.30894 17.5265 5.86446L13.0378 10.6737C12.6922 11.044 12.5 11.5317 12.5 12.0383V15.2153C12.5 15.5941 12.286 15.9403 11.9472 16.1097L8.94717 17.6097C8.28227 17.9422 7.49996 17.4587 7.49996 16.7153V12.0383C7.49996 11.5317 7.30772 11.044 6.96207 10.6737L2.47346 5.86446C1.95498 5.30894 1.66663 4.57738 1.66663 3.8175V3.66666Z"
      stroke="currentColor"
      fill="none"
      strokeWidth="1.5"
    />
  </SvgIcon>
)
